(function (window, $, Argument, app) {
    var Array = window.Array;
    var JSON = window.JSON;
    var document = window.document;
    var clearTimeout = window.clearTimeout;
    var setTimeout = window.setTimeout;
    var google = window.google;

    if (typeof google === 'undefined') {
        return;
    }

    function Map() {
        var _this = this;
        var maps = {};

        var areaColor = '#00A681';

        this.init = function (id, center, styles, areas) {
            var map = {};
            var options = center;

            if (typeof styles !== 'undefined') {
                options.styles = styles;
            }

            options.scrollwheel = false;

            map.id = id;
            map.el = document.getElementById(id);
            map.created = false;
            map.options = options;
            map.areas = areas;

            maps[id] = map;
        };

        this.getMap = function (id) {
            return maps[id];
        };

        var highlightAreas = function (map) {
            var processAreaData = function (data, i) {
                area = new google.maps.Polygon({
                    paths: data,
                    strokeColor: areaColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: areaColor,
                    fillOpacity: .35
                });

                if (map.created) {
                    area.setMap(map);
                }

                map.areas[i] = area;
            };

            var getCallback = function (i) {
                return function (data) {
                    processAreaData(data, i);
                };
            };

            for (var i = 0; i < map.areas.length; i++) {
                $.getJSON(map.areas[i]).done(getCallback(i));
            }
        };

        this.create = function () {
            var tilesLoaded = function () {
                if (this.areas instanceof Array) {
                    for (var i = 0; i < this.areas.length; i++) {
                        if (typeof this.areas[i].getMap() === 'undefined') {
                            this.areas[i].setMap(this);
                        }
                    }
                }

                this.created = true;
            };

            var enableScrollwheel = function () {
                this.setOptions({scrollwheel: true});
            };

            var enableScrollwheelTimeout = null;

            var delayedEnableScrollwheel = function () {
                var _this = this;

                enableScrollwheelTimeout = setTimeout(function () {
                    enableScrollwheel.call(_this);
                }, 1000);
            };

            var disableScrollwheel = function () {
                if (enableScrollwheelTimeout) {
                    clearTimeout(enableScrollwheelTimeout);
                }

                this.setOptions({scrollwheel: false});
            };

            for (var id in maps) {
                var map = maps[id];

                if (map.created) {
                    continue;
                }

                map = $.extend(new google.maps.Map(map.el, map.options), map);

                highlightAreas(map);
                google.maps.event.addListenerOnce(map, 'tilesloaded', tilesLoaded);

                google.maps.event.addListener(map, 'click', enableScrollwheel);
                google.maps.event.addListener(map, 'dragstart', enableScrollwheel);
                google.maps.event.addListener(map, 'rightclick', enableScrollwheel);

                google.maps.event.addListener(map, 'mouseover', delayedEnableScrollwheel);
                google.maps.event.addListener(map, 'mouseout', disableScrollwheel);

                maps[id] = map;
            }
        };

        this.setZoom = function (mapId, zoom) {
            var map = this.getMap(mapId);

            map.setZoom(zoom);
            map.setCenter(map.options.center);
        };
    }

    app.Map = new Map();
})(window, jQuery, Argument, Template3);
